import { Box, LinearProgress, LinearProgressProps } from '@mui/material';

import { calculateExecutedVehiclesPercentage } from '../../utils/calculate-executed-vehicles-percentage/calculate-executed-vehicles-percentage';
import { CampaignsProgressBarLabel } from '../campaigns-progress-bar-label/campaigns-progress-bar-label';
import { CampaignCarsExecutionProgressBarProps } from './models/campaign-cars-execution-progress-bar.props';

const CampaignCarsExecutionProgressBar = ({
  totalVehiclesNumber,
  executedVehiclesNumber,
  ...props
}: LinearProgressProps & CampaignCarsExecutionProgressBarProps) => {
  return (
    <Box className="campaign-cars-execution-progress-bar-box">
      <Box className="campaign-cars-execution-progress-bar">
        <LinearProgress variant="determinate" {...props} />
      </Box>

      <Box className="campaign-cars-execution-progress-bar-label">
        <CampaignsProgressBarLabel
          labelText={`${executedVehiclesNumber} of ${totalVehiclesNumber} cars`}
        />

        <CampaignsProgressBarLabel
          labelText={`${Math.round(
            calculateExecutedVehiclesPercentage(
              executedVehiclesNumber,
              totalVehiclesNumber
            )
          )}%`}
        />
      </Box>
    </Box>
  );
};

export default CampaignCarsExecutionProgressBar;
